import { useEffect, useState } from "react";
import { UserRound, Terminal, Cylinder } from "lucide-react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { AccountSwitcher } from "./AccountSwitcher";
import {
  Sidebar,
  SidebarContent,
  SidebarFooter,
  SidebarGroup,
  SidebarGroupContent,
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  SidebarHeader,
  useSidebar,
} from "@/components/ui/sidebar";
import { AccountModel, useAuth } from "@/utils/AuthContext";

// Menu items.
const items = [
  {
    title: "Datasources",
    url: "/sources",
    icon: Cylinder,
  },
  {
    title: "Assistant",
    url: "/assistant",
    icon: Terminal,
  },
];

function AppSidebar() {
  const { user, currentAccount } = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [selection, setSelection] = useState<number>(0);
  const { isMobile } = useSidebar();

  useEffect(() => {
    const defaultIndex = items.findIndex((item) => {
      return location.pathname.startsWith(item.url);
    });

    setSelection(defaultIndex);
  }, []);

  const handleAccountClick = () => {
    const resumePath = location.pathname + location.search + location.hash;
    sessionStorage.setItem("resumePath", resumePath);
    navigate(`/login/${currentAccount?.slug ?? ""}`);
  };

  return (
    <Sidebar collapsible="icon" className="bg-sidebar pt-6">
      <SidebarHeader>
        <AccountSwitcher
          side={isMobile ? "bottom" : "right"}
          onSuccess={() => {
            // do a hard redirect to force reload
            window.location.href = "/";
          }}
          onFailure={(account: AccountModel) => {
            navigate(`/login/${account.slug}`);
          }}
          onAdd={() => {
            navigate("/login");
          }}
        />
      </SidebarHeader>
      <SidebarContent>
        <SidebarGroup>
          <SidebarGroupContent>
            <SidebarMenu className="gap-y-2">
              {items.map((item, i) => (
                <SidebarMenuItem key={item.title}>
                  <SidebarMenuButton
                    tooltip={item.title}
                    asChild
                    isActive={i === selection}
                    onClick={() => setSelection(i)}
                  >
                    <Link to={item.url}>
                      <item.icon strokeWidth={2.3} size={48} />
                      <span>{item.title}</span>
                    </Link>
                  </SidebarMenuButton>
                </SidebarMenuItem>
              ))}
            </SidebarMenu>
          </SidebarGroupContent>
        </SidebarGroup>
      </SidebarContent>
      <SidebarFooter className="bg-sidebar">
        <SidebarContent>
          <SidebarMenu>
            <SidebarMenuItem>
              <SidebarMenuButton tooltip={user.name} asChild onClick={handleAccountClick}>
                <UserRound strokeWidth={2.3} />
              </SidebarMenuButton>
            </SidebarMenuItem>
          </SidebarMenu>
        </SidebarContent>
      </SidebarFooter>
    </Sidebar>
  );
}

export default AppSidebar;
